<app-service-basic-info-form
    [serviceId]="0"
    [form]="form"
></app-service-basic-info-form>
